module.exports = __webpack_public_path__ + "assets/img/addCard.627f273f.png";